"use strict";
// @ts-ignore
try {
    self['workbox:expiration:6.4.1'] && _();
}
catch (e) { }
